import clsx from "clsx"
import GreekLineImg from "@/assets/imgs/greek-line.png"

const GreekLine = ({ isHidden = false, custCls = "" }) => {
  return (
    <>
      <div className={clsx("h-4 bg-white", { "hidden": isHidden }, custCls)}>
        <div className="absolute min-h-full min-w-full bg-cover md:bg-contain" style={{
          backgroundImage: `url(${GreekLineImg})`,
          backgroundRepeat: 'repeat-x',
          backgroundPosition: 'center'
        }}></div>
      </div>
    </>
  )
}

export default GreekLine